import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const bodyAssessment: ImportTypeConfig = {
  type: 'body_assessment',
}
